// extracted by mini-css-extract-plugin
module.exports = {"detail-header":"styles_detail-header__Qe2HT"};